import React from 'react'
import envios from "../../assets/images/camion-de-reparto.png";
import atencion from "../../assets/images/headset.png";
import presupuesto from "../../assets/images/budget.png";
import medicion from "../../assets/images/measure.png";
import colocacion from "../../assets/images/tool-box.png";
import "./style.css";

const services = [
    {
        image: presupuesto,
        description: "Presupuesto rápido",
        text: "Realizamos los mejores presupuestos en el rubro, ofreciendo precios inmejorables y un trabajo de excelente calidad."
    },
    {
        image: medicion,
        description: "Medición",
        text: "Nuestros especialistas se encargan de hacer la medición y asesorar en el proceso."
    },
    {
        image: colocacion,
        description: "Colocación",
        text: "Instalamos materiales con precisión y eficiencia en toda el área."
    },
    {
        image: envios,
        description: "Envíos a todo el país",
        text: "Enviamos nuestros productos a todo el país, no importa de dónde seas."
    },
    {
        image: atencion,
        description: "Atención post venta",
        text: "Acompañamos al cliente después de cada trabajo realizado."
    }
]

function Services() {
    return (
        <div className="flex flex-wrap -m-4 text-center justify-center mt-32 px-8 pb-20 mobile:mt-12">
            {services.map((service) => (
                <div key={service.description} className="animate__animated animate__fadeIn animate__delay-0-5s p-4 md:w-1/5 sm:w-1/3 w-1/2 h-full m-w-250">
                    <div className="bg-white px-4 py-5 rounded-2xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 min-h-180 h-full flex flex-col items-center justify-between">
                        <img className="w-20 h-20 mb-4 opacity-80" src={service.image} alt={service.description} />
                        <p className="leading-snug text-gray-700 font-semibold text-base">{service.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Services;
